import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import FeedbackList from './FeedbackList';
import FeedbackForm from './FeedbackForm';
import { variants } from '../../../variants/variants';
import { useDispatch } from 'react-redux';
import { setFeedbackStatus } from '../../Auth/authSlice';

const Feedbacks = () => {
  const [editingFeedback, setEditingFeedback] = useState(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const dispatch = useDispatch();
  const [inputHeight, setInputHeight] = useState(100);
  const [showToolbar, setShowToolbar] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const inputRef = useRef();
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const handleChange = (val) => {
    setInputHeight(val);
  };
  useLayoutEffect(() => {
    dispatch(setFeedbackStatus(false));
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      if (inputRef.current) {
        setInputHeight(inputRef.current.clientHeight);
      }
    };

    const handleFocus = () => {
      setKeyboardVisible(true);
      adjustBottomPosition();
    };

    const handleBlur = () => {
      setKeyboardVisible(false);
      adjustBottomPosition();
    };

    const adjustBottomPosition = () => {
      if (inputRef.current) {
        const bottomOffset = keyboardVisible && !showToolbar ? '80px' : '0px';
        inputRef.current.style.bottom = bottomOffset;
      }
    };

    window.addEventListener('resize', handleResize);

    // Event listeners for focus and blur on the form control
    if (inputRef.current) {
      const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
      formInputs.forEach((input) => {
        input.addEventListener('focus', handleFocus);
        input.addEventListener('blur', handleBlur);
      });
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      if (inputRef.current) {
        const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
        formInputs.forEach((input) => {
          input.removeEventListener('focus', handleFocus);
          input.removeEventListener('blur', handleBlur);
        });
      }
    };
  }, [keyboardVisible]);
  useLayoutEffect(() => {
    if (inputRef.current) {
      const bottomOffset = '0px';
      inputRef.current.style.bottom = bottomOffset;
      setInputHeight(inputRef.current.clientHeight);
    }
  }, [showToolbar]);
  return (
    <Grid
      container
      sx={{       
        height: `calc(100vh - ${isSm?'250px':'100px'})`,
        display: 'flex',
        flex: 1,
        borderRadius: variants.boxRadius.NAVBAR,       
      }}
    >
      <Grid
        container
        sx={{
          position: 'relative',
          borderRadius: variants.boxRadius.NAVBAR,
          background: 'white',
          border: 1,
          borderColor: 'divider',
          display: 'flex',
          flex: 1,
          height:"100%"
        }}
      >
        <>
          <Grid
            item
            xs={12}
            sx={{
              position: 'relative',
              overflow: 'scroll',
              paddingBottom: '0',
              height: isSm ? '85%':`calc(90vh - ${inputHeight}px)`
            }}
          >
            <FeedbackList
              setEditingFeedback={setEditingFeedback}
              showScrollButton={showScrollButton}
              setShowScrollButton={setShowScrollButton}
              inputHeight={inputHeight}
            />
          </Grid>
          <Grid item xs={12} sx={{ position: 'absolute', bottom: 20, left: 0, right: 0,height:isSm?"15%":"10%"}}>
            <FeedbackForm
              editingFeedback={editingFeedback}
              setEditingFeedback={setEditingFeedback}
              showScrollButton={showScrollButton}
              onChange={handleChange}
              inputRef={inputRef}
              showToolbar={showToolbar}
              setShowToolbar={setShowToolbar}
            />
          </Grid>
        </>
      </Grid>
    </Grid>
  );
};

export default Feedbacks;
